// catch-all: tanstack router owns all client-side routing
export default "/*";
